//key used when working with a pet list for a single user
export const PETS = "pets";

//key for pets dropdown
export const PETS_DROP_DOWN = "pets_dropdown";
export const PETS_FOR_BOXES_DROP_DOWN = "pets_for_boxes_dropdown";

//These 3 keys are used to store data on the pets tabs on the single pet view
//Make sure a unique key is stored with each query key
export const PETS_GENERAL = "p_general";
export const PETS_NOTES = "p_notes";
export const PETS_DOCUMENTS = "p_documents";
export const PETS_APPOINTMENTS = "p_appointments";
export const PETS_APPOINTMENTS_WEEK = "p_appointments_this_week";
export const PET_BIOMETRICS_DATA = "p_biometrics";
export const PET_AVATAR = "p_avatar";

//Key used to store pets in the clinic user page
//Make sure a unique user Id is always passed with this key
export const USER_CLINIC_PETS = "userPets";
//Key used to store pets in user home page
//Make sure a unique user Id is always passed with this key
export const PETS_USER_HOMEPAGE = "pets_user_homepage";

//key for users appointment list
export const APPOINTMENTS = "appointments";
export const APPOINTMENTS_INFINITE = "appointments_infinite";
export const APPOINTMENTS_TABLE_KEY = "appointments_table_key";
export const APPOINTMENTS_USER_HOMEPAGE = "appointments_user_homepage";

//key for pending appointments calendar
export const PENDING_APPOINTMENTS_CALENDAR = "pending_appointments_calendar/";

//These keys are used to store data on on the appointments tab
export const APPOINTMENT_GENERAL = "a_general";
export const APPOINTMENT_FILES = "a_files";
export const APPOINTMENT_DOCTORS_LETTER = "a_doctors_letter";
export const APPOINTMENT_AUDIT = "a_audit";
export const APPOINTMENT_BIOMETRICS_DATA = "a_biometrics";

//key for pending appointments
export const PENDING_APPOINTMENTS = "pending_appointments";
export const PENDING_APPOINTMENTS_HOMEPAGE = "pending_appointments_homepage";

//key for users permissions
export const PERMISSIONS = "permissions";
export const PERMISSIONS_EDIT = "permissions_edit_key";

//key for working days
export const WORKING_DAYS = "working_days";

//Keys for templates
export const TEMPLATE = "template-q-key";
export const TEMPLATES_LIST = "template-list-q-key";
export const TEMPLATES_DROPDOWN = "template-dropdown-q-key";
export const PRESCRIPTION_TEMPLATE = "prescription-template-q-key";
export const PRESCRIPTION_TEMPLATES_LIST = "prescription-template-list-q-key";
export const REFERRAL_TEMPLATE = "referral-template-q-key";
export const REFERRAL_TEMPLATES_LIST = "referral-template-list-q-key";
export const INSTITUTIONS_LIST = "institutions-list-q-key";

//Keys for about us
export const ABOUT_US = "about_us";
export const BANNER = "banner";

//Keys for navigation bar
export const NAVBAR = "navigation_bar";
export const LOGO = "logo";

//Keys for clinics
export const CLINICS = "clinics_list";
//---- Species key for clinic
export const SPECIES_CLINIC = "species_clinic";
// Plain species array for the new-pet dropdowns - must not share SPECIES_CLINIC,
// which caches the species page's { clinics, species, allowsAllSpecies } object
export const SPECIES_BOOKING_MODAL = "species_booking_modal";
//---- Key for all the user roles of a clinic
export const USERS_CLINIC = "users_clinic";
//---- Key for single user role of a clinic
export const USERS_CLINIC_SINGLE = "users_clinic_single";
export const EDITING_USER_DETAILS = "master_user_editing_key";
//---- Key for working hours table
export const WORKING_HOURS_TABLE = "working_hours_table";
//---- Key for non working hours list
export const NON_WORKING_HOURS_LIST = "working_hours_list";

//Keys for master
//---- Species keys
export const SPECIES_MASTER = "species_master";
//---- Clinics keys
export const CLINICS_MASTER = "clinics_master";

//Keys for employees
//---- All employees for lists and arrays
export const EMPLOYEES = "all_employees";
//---- Key for viewing single employee
export const EMPLOYEE_SINGLE = "single_employee";

//Keys for users
//---- Key for currently logged in user
export const LOGGED_IN_USER = "logged_in_user";

//Keys for login
//---- Key for any user related data directly after logging in
export const LOGIN_KEYS = "login_keys";
//---- Key for any token related data
export const TOKENS_KEY = "tokens_key";

//---- Key for non logged in users profile page
export const USER_Q = "single_user_query";
//---- Might add key for user profile but that should be shared with LOGGED_IN_USER

//---- Key for a list of users in the clinic (non employee)
export const USER_LIST = "non_employee_list";

//Keys for services
export const SERVICES = "services_key";

//Keys for information fields
export const INFO_FIELD = "information_fields_key";

//Keys for document categories
export const DOC_CATEGORY = "document_category_key";

//Keys for inbox
export const CONVO_PREVIEW_ID = "convo_preview_by_id";
export const CONVO_TO_UPDATE_ID = "convo_to_update_by_id";

//Keys for Feedbacks
export const FEEDBACK_SUBMIT = "user_feedback";
//Keys for treatment
export const TREATMENT = "treatment";

export const BOXES_LIST_KEY = "saps_boxes_key";

export const TIER = "tier";

export const ROLE = "role";

export const WAREHOUSE_ITEMS = "warehouse_items";

export const WAREHOUSE_ITEM = "warehouse_item";

export const WAREHOUSE_CODE_PREFIX = "warehouse_code_prefix";

export const WAREHOUSE_PREFERENCES = "warehouse_preferences";

export const WAREHOUSE_SUPPLIERS = "warehouse_suppliers";

export const INVOICE_SETTINGS = "invoice_settings";

export const WAREHOUSE_CATEGORIES = "warehouse_categories";

export const WAREHOUSE_ITEM_AUDITING = "warehouse_item_auditing";

export const WAREHOUSE_ITEM_QR_CODE = "warehouse_item_qr_code";

export const SINGLE_BOX_THERAPY = "single_box_therapies_key/";

export const SINGLE_ARCHIVED_INPATIENT_THERAPY =
  "single_archived_inpatient_therapy_key/";

export const SINGLE_THERAPY_KEY = "single_therapy_view_key/";

export const SINGLE_THERAPY_DAY_KEY = "single_therapy_day_key/";

export const ALERTS_IN_BOX = "list_of_alerts_in_box";

export const THERAPY_DAY_KEY = "therapy_days_fetch_";

export const THERAPY_DAYS_FETCH = "therapy_days_fetch_";

export const SINGLE_BOX_KEY = "single_box_key/";

export const SINGLE_ARCHIVE_KEY = "single_archive_key/";

export const SINGLE_ARCHIVE_VIEW_KEY = "single_archive_view_key/";

export const BOX_ARCHIVE_KEY = "box_archive_key/";

export const BLOOD_DONORS_KEY = "blood_donor_key";

export const SINGLE_PET_IN_BOX_KEY = "single_pet_in_box_";
export const SAPS_PET_NOTES_KEY = "single_pet_notes_key";

export const MARK_THERAPY_DONE = "mark_therapy_done/";

export const GET_ARCHIVED_MEDICAL_DAYS = "get_archived_medical_days_key/";

export const PET_HEALTH_SUMMARY = "pet_health_summary";

export const TIME_SLOTS = "timeslots_key";

export const SINGLE_BOX_INPATIENT_STAY = "single_pet_in_box_inpatient_stay";

export const GET_INPATIENT_STAY = "inpatient-stays";

export const PET_HEALTH_TREATMENT_SUMMARY = "pet_health_treatment_summary";

export const PET_HEALTH_RECORDS = "pet_health_records_key/";

export const THERAPY_DAY_DATES = "therapy_day_dates_key/";

export const QR_REDIRECT_URL = "qr_redirect_url";

export const QR_CODE_IMAGE = "qr_code_image";

export const MOVE_PET_AVAILABE_BOXES = "available-boxes-for-move";

export const AVAILABLE_BOXES_KEY = "available_boxes/";

export const ARCHIVE_LIST = "archive_list/";

export const GET_ALL_ACTIVE_THERAPIES_KEY = "active_therapies_key";

export const WAREHOUSE_ITEMS_SUBMIT = "warehouse_items_key/";

export const ASSIGN_RESOURCE_TO_SERVICE = "assign_resource_to_service_key/"
